import React from 'react';
import './LegalPage.css';

const PrivacyPolicy = () => {
  return (
    <section className="legal-page">
      <div className="container">
        <div className="legal-header">
          <span className="section-tag">🔒 Legal</span>
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last updated: January 2024</p>
        </div>

        <div className="legal-content">
          <div className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              At Slink ("we", "our", "us"), we are committed to protecting your privacy and personal data. 
              This Privacy Policy explains how we collect, use, and safeguard your information when you use our 
              mobile application and services.
            </p>
            <p>
              For any privacy-related queries, contact us at: <a href="mailto:slink@astergo.in" className="legal-link">slink@astergo.in</a>
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Information We Collect</h2>
            <p>We collect the following information during registration:</p>
            <ul>
              <li>Display name (chosen by you)</li>
              <li>Phone number (for verification only)</li>
              <li>Email address (for account recovery)</li>
              <li>Profile photos (uploaded by you)</li>
              <li>Gender, state, and city (for matching purposes)</li>
              <li>Bank/UPI details (for withdrawal of earnings only)</li>
            </ul>
          </div>

          <div className="legal-section highlight-box">
            <h2>3. We Do NOT Share Your Personal Data</h2>
            <p><strong>We do not share, sell, rent, or disclose your personal information to any third party, other users, or external organizations.</strong></p>
            <p>This includes but is not limited to:</p>
            <ul>
              <li>Your real name is never displayed to other users</li>
              <li>Your phone number is completely hidden from all other users</li>
              <li>Your email address is never shared or visible to anyone</li>
              <li>Your bank account/UPI details are strictly confidential and never shared</li>
              <li>Your exact location is never disclosed to other users</li>
            </ul>
            <p>Other users can only see your display name, profile photos, gender, state, and city — nothing more.</p>
          </div>

          <div className="legal-section">
            <h2>4. How We Use Your Information</h2>
            <ul>
              <li>Phone number: Solely for OTP verification and account security</li>
              <li>Email: For account recovery and important service notifications</li>
              <li>Bank details: Only to process your earning withdrawals</li>
              <li>Location (state/city): To help match users in nearby areas</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>5. Data Security</h2>
            <p>
              We implement industry-standard security measures including encryption, secure servers, 
              and access controls to protect your personal data. Video calls are protected with 
              screenshot/screen recording prevention technology.
            </p>
          </div>

          <div className="legal-section warning-box">
            <h2>6. User Conduct & Account Suspension</h2>
            <p><strong>Sharing personal contact information in chat is strictly prohibited.</strong></p>
            <p>If a user is found violating the following rules:</p>
            <ul>
              <li>Sharing phone numbers in chat messages</li>
              <li>Sharing email addresses in chat</li>
              <li>Sharing social media handles or external contact details</li>
              <li>Requesting other users' personal information</li>
            </ul>
            <p className="legal-warning">
              <strong>First violation:</strong> The user will receive a warning notice.<br />
              <strong>Second violation:</strong> The user's account will be permanently blocked without any refund of wallet balance.
            </p>
            <p>
              This policy exists to protect all users' privacy and maintain a safe community.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Data Retention</h2>
            <p>
              We retain your personal data only as long as your account is active. Upon account deletion, 
              all personal data including messages, call history, and profile information will be permanently 
              deleted within 30 days.
            </p>
          </div>

          <div className="legal-section">
            <h2>8. Third-Party Services</h2>
            <p>
              We use Razorpay for payment processing. Razorpay has its own privacy policy governing 
              payment data. We do not store your full payment card details on our servers.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Users will be notified of significant 
              changes via in-app notification or email.
            </p>
          </div>

          <div className="legal-section">
            <h2>10. Contact Us</h2>
            <p>For any questions or concerns regarding this Privacy Policy:</p>
            <ul>
              <li>Email: <a href="mailto:slink@astergo.in" className="legal-link">slink@astergo.in</a></li>
              <li>Address: Kolkata, West Bengal, India</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
